<template>
    <div class="user_order" v-loading="loading">
        <div class="order_titles">我的订单</div>
        <div class="user_order_box">
            <div class="order_types">
                <div class="lefts">
                    <div class="types" :class="{types_ac:types_ac==item.state}" v-for="(item,index) in type_list" :key="index" @click="handle_type(item)">
                        {{ item.title }}
                    </div>
                </div>
                <div class="rights">
                    <el-input
                        placeholder="输入商品名称、订单号"
                        v-model="keyword">
                        <div slot="suffix" class="" @click="handle_seach">
                            <img src="../../../../assets/img/user_info/user_order/seach.png" alt="">
                        </div>
                    </el-input>
                </div>
            </div>
            <div class="order_0" v-if="order_list.length==0">
                <img src="@/assets/img/user_info/user_grzx/order_0.png" alt="">
                <div class="texts">暂无待处理订单</div>
            </div>
            <div class="order_list" v-if="order_list.length!=0">
                <div class="order_item" v-for="(item,index) in order_list" :key="index">
                    <div class="item_titles">
                        <div class="order_lefts">
                            <div class="order_time">{{ item.created_at }} </div>
                            <div class="order_no">订单号：{{ item.order_sn }}</div>
                        </div>
                        <div class="order_rights">
                            {{ item.status==10?'待付款':'' }}
                            {{ item.status==20?'待服务':'' }}
                            {{ item.status==30?'服务中':'' }}
                            {{ item.status==40?'已结项':'' }}
                            {{ item.status==50?'已评价':'' }}
                        </div>
                    </div>
                    <div class="order_info">
                        <div class="shop_list">
                            <div class="shop_item" >
                                <div class="shop_left">
                                    <div class="shop_img">
                                        <!-- <img src="@/assets/img/index/legal/bg1.png" alt=""> -->
                                         <img :src="(item.pro||{}).thumb" alt="">
                                    </div>
                                    <div class="shop_title">{{ (item.pro||{}).title }}</div>
                                </div>
                                <div class="shop_right">
                                    <div class="shop_price1" v-if="item.jifen_id">{{(item.pro||{}).jifen}}积分+{{(item.pro||{}).money}}元</div>
                                    <div class="shop_price1" v-else>{{(item.pro||{}).price}}元</div>
                                    <div class="shop_num">X1</div>
                                    <div class="shop_price2" v-if="item.jifen_id">{{(item.pro||{}).jifen}}积分+{{(item.pro||{}).money}}元</div>

                                    <div class="shop_price2" v-else>{{(item.pro||{}).price}}元</div>
                                </div>
                            </div>
                        </div>
                        <div class="order_btns">
                            <div class="btns_lefts">
                                <div class="text1">
                                    共
                                    <span>1</span>
                                    个商品
                                </div>
                                <div class="text2">
                                    合计金额
                                    <span v-if="item.jifen_id">{{(item.pro||{}).jifen}}</span>
                                    {{ item.jifen_id?'积分':'' }}
                                    <span v-if="item.jifen_id">+{{(item.pro||{}).money}}</span>
                                    <span v-else> {{ item.price }}</span>
                                    元 
                                </div>
                            </div>
                            <div class="btns_right">
                                <div class="btns1" @click="handle_fp(item)">下载发票{{item.kaipiao_file}}</div>
                                <div class="btns1" @click="handle_deitial(item)">订单详情</div>
                                <div class="btns2" @click="handle_pay(item)" v-if="item.status==10">去支付</div>
                                <div class="btns2" @click="handle_end(item)" v-if="item.status==30">确认完成</div>
                                <div class="btns2"  @click="handle_pl(item)" v-if="item.status==40">写评价</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="pages_box">
                <div class="btns" @click="handle_pages(1)">首页</div>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pages.page"
                    background
                    :page-size="pages.limit"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
                <div class="btns"  @click="handle_pages(10)">尾页</div>
            </div>
        </div>
        <user_order_qx ref="user_order_qx"></user_order_qx>
        
    </div>
</template>
<script>
import { mapState} from 'vuex'
import user_order_qx from '@/components/user_order/user_order_qx.vue'//律所
 
 

export default {
    components: {
        user_order_qx,
       
    },
    name: "homes",
    data() {
        return {
            loading: false,
            keyword:'',//
            types_ac:0,
            type_list:[
                {
                    title:'全部服务订单',
                    state:0,
                },
                {
                    title:'待付款',
                    state:10,
                },
                {
                    title:'待服务',
                    state:20,
                },
                {
                    title:'服务中',
                    state:30,
                },
                {
                    title:'已结项',
                    state:40,
                },
                {
                    title:'已评价',
                    state:50,
                },
                
            ],
            order_list:[],

            total:100,
            pages:{
                page:1,
                limit:10,
            },
           
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        if(this.$route.query.types_ac){
            this.types_ac=this.$route.query.types_ac
        }
        this.get_list()
    },
    methods: {
        handle_type(item){
            this.types_ac=item.state   
            this.pages.page=1
            this.get_list()

        },
        handle_seach(){
            console.log('点击搜索')
            this.pages.page=1
            this.get_list()
        },
        handleSizeChange(e){
            console.log('条数',e)            
        },
        handleCurrentChange(e){
            console.log('页数',e)
            this.pages.page=e
            this.get_list()
        },
        handle_pages(i){
            console.log('首页尾页',i)
            this.pages.page=i
            this.get_list()
        },
        get_list(){
            this.loading = true
            this.$api("myOrderList", {
                status:this.types_ac,
                ...this.pages,
                is_over:1
			}, "get").then((res) => {
                this.loading = false
                console.log('我的订单列表',res)
                if (res.code == 1) {
                    this.order_list=res.data.data
                    this.total=res.data.total
                    this.last_page=res.data.last_page
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_fp(item){
            console.log('发票',item)
        },
        handle_deitial(item){
            this.$router.push({
                path:'/user_order/order_detial',
                query:{
                    id:item.id
                }
            })
        },
        handle_pay(item){
            this.$router.push({
                path:'/Legal_pay',
                query:{
                    order_id:item.id,
                    pro_id:item.pro_id
                }
            })
        },
        handle_end(item){
            this.$confirm('确定完成服务?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.handle_end2(item)
            }).catch(() => {
               
            });
        },
        handle_end2(item){
            this.loading = true
            this.$api("finishOrder", {
               id:item.id
             
			}, "post").then((res) => {
                this.loading = false
                console.log('我的订单列表',res)
                if (res.code == 1) {
                    alertSucc('服务完成')
                   this.get_list()
                } else {
                    alertErr(res.msg)
                }
            });
        },

        handle_pl(item){
            this.$router.push({
                path:'/user_order/order_pj',
                query:{
                    id:item.id
                }
            })
        },

    },

}
</script>
<style scoped lang="less">
.user_order {
    .order_titles{
        width: 1196px;
        height: 56px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        padding: 0 32px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 16px;
        color: #333333;
        line-height: 56px;
    }
    .user_order_box{
        padding: 24px 32px;    
        margin-top: 24px;
        background: #FFFFFF;
        border-radius: 0px 0px 0px 0px;
        .order_types{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .lefts{
                display: flex;
                align-items: center;
                .types{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    padding-bottom: 12px;
                    margin-right: 48px;
                    border-bottom: 4px solid #FFFFFF;
                    cursor: pointer;
                    &:hover{
                        border-bottom: 4px solid #377CFD;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #377CFD;
                    }
                }
                .types_ac{
                    border-bottom: 4px solid #377CFD;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 14px;
                    color: #377CFD;

                }
            }
            .rights{
                /deep/.el-input{
                    width: 282px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    // border: 1px solid #B8C4D1;
                    .el-input__inner{
                        width: 282px;
                        height: 32px;
                    }
                    .el-input__suffix{
                        display: flex;
                        // line-height: 32px;
                        margin-right: 3px;
                        align-items: center;
                        cursor: pointer;
                        img{
                            width: 18px;
                        }
                    }
                }
            }
        }
        .order_0{
            text-align: center;
            padding-top: 65px;
            img{
               width: 190px; 
            }
            .texts{
                padding-top: 16px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;

            }
        }
        .order_list{
            padding: 32px 0;
            .order_item{
                // width: 1132px;
                min-height: 260px;
                background: #FFFFFF;
                border-radius: 0px 0px 0px 0px;
                border: 1px solid #E5E5E5;
                margin-bottom: 10px;
                .item_titles{
                    // width: 1132px;
                    height: 44px;
                    background: #F5F5F5;
                    border-radius: 0px 0px 0px 0px;
                    border: 1px solid #E5E5E5;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding:0 24px ;
                    .order_lefts{
                        display: flex;
                        align-items: center;
                        .order_time{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #333333;
                            margin-right: 20px;
                        }
                        .order_no{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #333333;
                        }
                    }
                    .order_rights{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 14px;
                        color: #377CFD;

                    }
                }
                .order_info{
                    padding:0 24px;
                    padding-top: 24px;
                    .shop_list{
                        
                        border-bottom: 1px solid #E5E5E5;
                        .shop_item{
                            margin-bottom: 24px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            .shop_left{
                                display: flex;
                                align-items: center;
                                .shop_img{
                                    width: 104px;
                                    height: 104px;
                                    img{
                                        width: 104px;
                                        height: 104px;
                                    }
                                }
                                .shop_title{
                                    padding-left: 24px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: #333333;
                                }
                            }
                            .shop_right{
                                display: flex;
                                align-items: center;
                                .shop_price1{
                                    width: 150px;
                                    text-align: left;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: #333333;

                                }
                                .shop_num{
                                    width: 100px;
                                    text-align: left;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: #333333;
                                }
                                .shop_price2{
                                    width: 150px;
                                    text-align: left;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 16px;
                                    color: #333333;


                                }
                            }
                        }
                    }
                    .order_btns{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        height: 64px;
                        .btns_lefts{
                            display: flex;
                            align-items: center;
                            .text1{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                                span{
                                    color: #377CFD;
                                    font-weight: bold;
                                }
                            }
                            .text2{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                                margin-left: 20px;
                                span{
                                    color: #377CFD;
                                    font-weight: bold;

                                }
                            }
                        }
                        .btns_right{
                            display: flex;
                            align-items: center;
                            .btns1{
                                width: 104px;
                                height: 32px;
                                background: #FFFFFF;
                                border-radius: 4px 4px 4px 4px;
                                border: 1px solid #377CFD;
                                line-height: 32px;
                                text-align: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #377CFD;
                                cursor: pointer;
                                margin-left: 10px;

                            }   
                            .btns2{
                                width: 104px;
                                height: 32px;
                                background: #377CFD;
                                border-radius: 4px 4px 4px 4px;
                                text-align: center;
                                line-height: 32px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #FFFFFF;
                                cursor: pointer;
                                margin-left: 10px;
                            }

                        }
                    }
                    

                }
            }
        }
        .pages_box{
                width: 100%;
                height: 100px;
                // background-color: red;
                display: flex;
                align-items: center;
                justify-content: end;
                /deep/.el-pagination{
                    .btn-prev{
                        background-color: #FFFFFF;
                        border: 1px solid #EEEEEE;  
                        
                    }
                    .el-pager{
                        .number {
                            background-color: #FFFFFF;
                            border: 1px solid #EEEEEE;  

                        }
                        .active{
                            background-color: #377CFD;
                        }
                        .el-icon{
                            background-color: #FFFFFF;
                        }
                    }
                    .btn-next{
                        background-color: #FFFFFF;
                        border: 1px solid #EEEEEE;  

                    }
                }
                .btns{
                    width: 40px;
                    height: 32px;
                    background: #FFFFFF;
                    border-radius: 4px 4px 4px 4px;
                    border: 1px solid #EEEEEE;  
                    font-family: PingFang-SC-Medium, PingFang-SC-Medium;
                    font-weight: normal;
                    font-size: 14px;
                    color: #7A7A7A;
                    text-align: center;
                    line-height: 32px;
                    cursor: pointer;
                }
            }
    }


}
</style>